/**
 * Check if a node is empty node
 * @param {string} id - Node id
 */
const isEmptyNode = (id: string): boolean => id.startsWith('empty_node');

export default isEmptyNode;
